// removed by extract-text-webpack-plugin
module.exports = {"badge":"Badge-badge"};